import React, { useState } from 'react';
import { MAX_LENGTH_QUESTION } from '../../config';

const withValidate = Component => props => {
  const [text, setText] = useState('');
  const [checkboxValue, setCheckboxValue] = useState(false);
  const maxLengthReached = text.length > MAX_LENGTH_QUESTION;
  const isValid = checkboxValue && !maxLengthReached;

  const formProps = {
    setText,
    text,
    checkboxValue,
    setCheckboxValue,
    maxLengthReached,
    isValid,
  };

  return <Component {...props} {...formProps} />;
};

export default withValidate;
